import * as React from 'react';

function SvgWarningStroke(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.902 25.24L16.52 4.476a1.7 1.7 0 00-3.04 0L3.096 25.24a1.7 1.7 0 001.521 2.46h20.764a1.7 1.7 0 001.52-2.46zM15.134 4.968a.3.3 0 01.134.134L25.65 25.866a.3.3 0 01-.268.434H4.618a.3.3 0 01-.268-.434L14.732 5.102a.3.3 0 01.402-.134zM14 12h2v7h-2v-7zm2 9h-2v2h2v-2z"
        fill={props.pathFill || '#414B56'}
      />
    </svg>
  );
}

export default SvgWarningStroke;
